"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const n3_1 = require("n3");
/**
 * Import all quads in the given stream into a new RDF store.
 *
 * The whole stream will be consumed for this,
 * and the promise will resolve once the stream's end event is emitted.
 *
 * @param {Stream<Q extends BaseQuad>} stream An RDF stream containing the quads to import into the store.
 * @return {Promise<Store<Q extends BaseQuad>>} A promise resolving to an RDF store.
 */
function storeStream(stream) {
    const store = new n3_1.Store();
    return new Promise((resolve) => store.import(stream).once('end', () => resolve(store)));
}
exports.storeStream = storeStream;
//# sourceMappingURL=index.js.map